import React from 'react';
import Home_Work from './Home_Work';
import '../../CommonCSS/SocietyCSS.css';

const Home_WorkApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> Home Work/Syllabus </h5>
          </div>
        </div>
        <Home_Work />
      </div>
    </div >
  );
};

export default Home_WorkApp;
